<common-card>
  <common-card-header>
    <h5>{{'auth.verify_phone_email.title' | translate}}</h5>
  </common-card-header>
  <common-card-body [formGroup]="form">
    <nb-alert *ngIf="user.pendingPhone" [outline]="phoneStatus">
      <div *ngIf="phoneStatus !== 'success'">
        <div class="mb-2">
          {{'auth.verify_phone_email.verify_otp' | translate}} <strong>{{user.pendingPhone}}</strong> :
        </div>
        <input formControlName="otp"
               nbInput
               inputmode="numeric"
               maxlength="6">
        <div class="mt-2" *ngIf="form.controls['otp'].enabled && showResendOtp">
          <a (click)="resendOtp()" class="small pointer">
            {{'auth.verify_phone_email.resend_otp' | translate}}
          </a>
        </div>
      </div>
      <div *ngIf="phoneStatus === 'success'">
        <div class="mr-3">
          <nb-icon icon="check" status="success" style="font-size:2rem;"></nb-icon>
        </div>
        <div>
          {{'auth.verify_phone_email.phone_verified' | translate}}
        </div>
      </div>
    </nb-alert>
    <nb-alert *ngIf="user.pendingEmail" [outline]="emailStatus" class="mt-4">
      <div *ngIf="emailStatus === 'info'">
        {{'auth.verify_phone_email.verify_email' | translate}} <strong>{{user.pendingEmail}}</strong><br>
        <span class="small">{{'auth.verify_phone_email.verify_email_spam_check' | translate}}</span>
      </div>
      <div *ngIf="emailStatus === 'success'">
        <div class="mr-3">
          <nb-icon icon="check" status="success" style="font-size:2rem;"></nb-icon>
        </div>
        <div>
          {{'auth.verify_phone_email.email_verified' | translate}}
        </div>
      </div>
    </nb-alert>
  </common-card-body>
  <common-card-footer>
    <div class="row justify-content-end">
      <div class="col-auto">
        <button type="submit"
                nbButton
                status="primary"
                [disabled]="(user.pendingPhone && phoneStatus !== 'success') || (user.pendingEmail && emailStatus !== 'success')"
                (click)="submit()">
          {{'global.buttons.submit' | translate}}
        </button>
      </div>
    </div>
  </common-card-footer>
</common-card>
